import { render, staticRenderFns } from "./InboundCockpitTM.vue?vue&type=template&id=6f8d74c8&scoped=true"
import script from "./InboundCockpitTM.vue?vue&type=script&lang=js"
export * from "./InboundCockpitTM.vue?vue&type=script&lang=js"
import style0 from "./InboundCockpitTM.vue?vue&type=style&index=0&id=6f8d74c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8d74c8",
  null
  
)

export default component.exports